/* Copyright (c) 2021-2026, NVIDIA CORPORATION.  All rights reserved.
*
* NVIDIA CORPORATION and its licensors retain all intellectual property
* and proprietary rights in and to this software, related documentation
* and any modifications thereto.  Any use, reproduction, disclosure or
* distribution of this software and related documentation without an express
* license agreement from NVIDIA CORPORATION is strictly prohibited.
*/

/** This file was automatically generated. DO NOT MODIFY IT BY HAND. */

/* eslint-disable @typescript-eslint/naming-convention */

export module AccessibilityTypes {

/** This object was automatically generated by json-schema-to-typescript. DO NOT MODIFY IT BY HAND. */

export interface Accessibility {
    [k: string]: any;
}
/**
 * This interface was referenced by `Accessibility`'s JSON-Schema
 * via the `definition` "AccessibilityInfo".
 */
export interface AccessibilityInfo {
    /**
     * List of any accessibility features that are enabled
     */
    accessibilityFeaturesEnabled: AccessibilityFeatureEnum[];
}

/**
 * This interface was referenced by `Accessibility`'s JSON-Schema
 * via the `definition` "AccessibilityFeatureEnum".
 */
export enum AccessibilityFeatureEnum {
    ScreenReader = 'ScreenReader'
}


}
